import { RootState } from '../store';

export const selectSuperuserUser = (state: RootState) => state.superuser.user;
export const selectSuperuserSupermode = (state: RootState) => state.superuser.supermode;
export const selectSuperuserLoading = (state: RootState) => state.superuser.loading;
export const selectSuperuserPendingNavigate = (state: RootState) =>
  state.superuser.pendingNavigate;
